import { DApp } from 'core'
import { createState } from 'shared'

import { LocalStorageKeys } from 'types'
import { loadObjectFromLocalStorage, saveObjectToLocalStorage } from 'utils'

// Initialize dApps state with data from localStorage
const initialDAppsState =
	loadObjectFromLocalStorage<DApp[]>(LocalStorageKeys.DApps) || []
const dAppsOpenState = createState<DApp[]>(initialDAppsState)

export const dAppsOpen = dAppsOpenState.state

// Update localStorage whenever the state changes
dAppsOpenState.onUpdateState(dApps => {
	saveObjectToLocalStorage(LocalStorageKeys.DApps, dApps)
})

// Functions to manage dApps state
export function addDApp(newDApp: DApp) {
	dAppsOpenState.updateState(dApps => {
		const exists = dApps.some(dApp => dApp.id === newDApp.id)

		if (exists) {
			return dApps
		}
		return [newDApp, ...dApps]
	})
}

export function removeDApp(dAppId: string) {
	dAppsOpenState.updateState(dApps => dApps.filter(dApp => dApp.id !== dAppId))
}
